import styled, {css} from 'styled-components';

import {
  Button as BaseButton,
  ModalContent as BaseModalContent,
  Td as BaseTd,
  Textarea as BaseTextarea,
  Th as BaseTh,
  getTableCellWidth,
} from '@edna/components';
import {Row as BaseRow} from '@edna/components/primitives';
import {mixins} from '@edna/components/styles';

import {Badge as BaseBadge} from 'src/components';
import {ModalCenterImage as BaseModalCenterImage} from 'src/components/primitives';
import {CopyIcon as BaseCopyIcon} from 'src/icons';

const COLUMNS_WIDTH = ['11%', '34%', '16%', '39%'];

export const Th = styled(BaseTh)`
  ${getTableCellWidth(COLUMNS_WIDTH)}
`;

export const Td = styled(BaseTd)`
  ${mixins.stack({direction: 'ROW', size: '2', justify: 'space-between'})}
  ${getTableCellWidth(COLUMNS_WIDTH)}
`;

export const ChannelIcon = styled.div`
  ${mixins.wh('17px')}
  margin-right: ${({theme}) => theme.spacing.s4};
`;

export const Type = styled.div`
  ${mixins.flexAlign('flex-start', 'center')}
`;

export const Badge = styled(BaseBadge)`
  white-space: nowrap;
`;

export const Button = styled(BaseButton)`
  white-space: nowrap;
`;

export const ModalContent = styled(BaseModalContent)`
  ${({theme: {spacing, palette}}) => css`
    margin-top: ${spacing.s4};
    padding-top: ${spacing.s2};
    border-top: solid 1px ${palette.grey100};
  `}
`;

export const Description = styled.div`
  ${mixins.f1}
  margin: 0;
  white-space: pre-wrap;
  ${({theme}) => css`
    color: ${theme.branding.content.secondary};
    max-width: 500px;
  `}
`;

export const StartRow = styled(BaseRow)`
  ${mixins.flexAlign('flex-start')};
`;

export const CopyIcon = styled(BaseCopyIcon)`
  cursor: pointer;
  ${mixins.wh('24px')}
  min-width: 24px;
  ${({theme}) => css`
    color: ${theme.branding.content.tertiary};
    margin-left: ${theme.spacing.s1};
  `}
`;

export const Textarea = styled(BaseTextarea)`
  font-weight: 500;
  ${({theme: {spacing}}) => css`
    margin: ${spacing.s2} ${spacing.s2} ${spacing.s10} 0;
  `}
`;

export const ModalCenterImage = styled(BaseModalCenterImage)`
  color: ${({theme}) => theme.branding.colors.accentB};
`;
